type TrustedForm = { xxTrustedFormCertUrl?: string; xxTrustedFormPingUrl?: string; xxTrustedFormToken?: string };

const getFieldValue = (fieldName: string) => {
  return (document.querySelector(`[name="${fieldName}"]`) as HTMLInputElement)?.value ?? '';
};

export const getTrustedForm = (): TrustedForm => {
  const xxTrustedFormToken = getFieldValue('xxTrustedFormToken');
  const xxTrustedFormCertUrl = getFieldValue('xxTrustedFormCertUrl');
  const xxTrustedFormPingUrl = getFieldValue('xxTrustedFormPingUrl');

  if (xxTrustedFormToken && xxTrustedFormCertUrl && xxTrustedFormPingUrl) {
    return { xxTrustedFormToken, xxTrustedFormCertUrl, xxTrustedFormPingUrl };
  }

  return {};
};
